// extracted by mini-css-extract-plugin
export default {"lang":"style_lang__-NXjZ"};